<template>
    <div v-if="showpage" class="respondPage">
        <van-nav-bar :title="duration">
            <template #left left-arrow>
                <i @click="onTopic()" class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
                <span>{{examType}}题</span>
            </template>
            <template #right>
                <span style="font-size: 22px; color: #202124; padding-right: 5px">{{currentRanking}}</span>
                <span style="padding-top: 3px">/ {{examTotal}}</span>
            </template>
        </van-nav-bar>
        <!-- 题目内容 -->
        <van-notice-bar color="#1972ff" background="#ecf9ff" left-icon="label-o" @click="dialogShow = true">
            <p class="protocol">测评简介</p>
        </van-notice-bar>
        <div class="examContent">
            <h3 class="examContent-topic" v-html="currentQuestion.title">{{currentQuestion.title}}</h3>
            <div class="examContent-option">
                <ul>
                    <li
                        v-for="(item, index) in currentQuestion.optionList"
                        @click="activebtn(item)"
                        :class="chooseNum === item.optionNumber ? 'activeSpan' : ''"
                        :key="index"
                    >
                        <span>{{item.optionNumber}}.</span>
                        <p class="optionContent" v-html="item.optionContent">{{item.optionContent}}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bottomBtn">
            <div class="tubiao">
                <p @click="isSheetShow = !isSheetShow">
                    <img src="../../../assets/images/exam/datika.png" alt />
                    <span>答题卡</span>
                </p>
            </div>
            <div class="btn">
                <van-button plain round type="info" class="commit" @click="commitPaper">交卷</van-button>
                <van-button
                    :disabled="currentRanking === 1"
                    round
                    type="info"
                    class="changeBtn"
                    @click="changeTopic('prev')"
                >上一题</van-button>
                <van-button
                    :disabled="currentRanking === examTotal"
                    round
                    type="info"
                    class="changeBtn"
                    @click="changeTopic('next')"
                >下一题</van-button>
            </div>
            
        </div>
        <!-- 答题卡 -->
        <van-action-sheet v-model="isSheetShow" title="答题卡" :close-on-click-action="true">
            <span class="examTotal"> /共{{ examTotal }}题</span>
            <div class="sheet-content">
                <div class="sheet-content-type">
                    <span class="answered">
                        已答
                        <span class="answered-num">{{rightCount}}</span>
                    </span>
                    <span class="unanswered">
                        未答
                        <span class="answered-num">{{examTotal-rightCount}}</span>
                    </span>
                </div>
            </div>
            <div class="sheet-num">
                <span
                    @click="toThisOne(index)"
                    :class="setColor(item)"
                    v-for="(item, index) in questionsList"
                    :key="index"
                >
                    {{index + 1}}
                </span>
            </div>
            <div>
                <van-button
                    style="width: 100%;font-size: 16px;font-weight: 550; margin-top: 40px"
                    round
                    type="info"
                    @click="commitPaper"
                >交卷</van-button>
            </div>
        </van-action-sheet>

      <van-dialog v-model="dialogShow" title="测评简介" confirmButtonText="确定" class="intro-dialog" @confirm="handleCloseProtocol()">
        <p class="tip-text">{{leariningMsg.assessIntroduce }}
        </p>
      </van-dialog>

    </div>
</template>

<script>
import { Dialog } from 'vant';
import { formatTime } from "../../exam/libs/timeformate.js";
export default {
    name: "respondPage",
    data() {
        return {
            assessTime:'',
            timer:'',
            isSheetShow: false,
            leariningMsg:'',
            questionsList: [],
            examTotal: null,
            examType: "单选",
            currentQuestion: {},
            currentRanking: 1,
            duration: '',
            chooseNum: null,
            singleParams: {},
            allAnswer: [],
            rightCount: 0,
            examParams: {
                userPaperId: null,
                examId: null,
            },
            answerTime: null,
            showpage: false,
            dialogShow: false,
        };
    },
    components: {
    },
    computed: {
    },
    watch: {
        "questionsList" : {
            handler: function(newV) {
                let arr = [];
                arr = newV.filter((item) => {
                    return item.responds === 1;
                })
                this.rightCount = arr.length;
            },
            deep: true,
        },
    },
    beforeDestroy () {
        window.removeEventListener('popstate', this.backChange, false);//false阻止默认事件
    },
    methods: {
      handleCloseProtocol() {
        this.dialogShow = false
      },
        backChange(){
            this.commitPaper();
        },
        setColor(item) {
            if(item.responds || (item.result === 1 && item.reply)) {
                return 'answeredTopic';
            }
            if(!item.reply || !item.responds){
                return 'unansweredTopic';
            }
        },
        // 如果是单选、判断直接进入下一题
        activebtn(val) {
            this.chooseNum = val.optionNumber;
            let params = {
                userAnswer: '',
                questionId: val.questionId,
                questionType: this.currentQuestion.type
            }
            // 单选、判断
            this.questionsList[this.currentRanking-1].responds = 1;
            this.$set(this.questionsList, this.currentRanking-1, this.questionsList[this.currentRanking-1])
            params.userAnswer = val.optionNumber;
            this.repetAnswer(params);
            if (this.currentRanking !== this.examTotal) {
                this.$nextTick(()=>{
                    this.changeTopic("next");
                })
            }
        },
        // 全部题目提交
        async allCommit() {
            this.singleParams = {
                userAnswerVoList: this.allAnswer,
                refId: this.examParams.refId,
                refType: this.examParams.refType,
                endTime: formatTime(new Date()),
                startTime: this.answerTime,
                assessId: this.examParams.id,
            };
            let data = this.singleParams;
            Dialog.close();
            await this.$api.testreport.reportSaveUserAnswer({data}).then(res => {
                if(!res.code){
                    +this.$route.query.respondlink ? this.$router.push({
                        path: "/humanResting/respondlink"
                    }) : this.$router.push({
                        path: '/humanResting/hrDetails',
                        query: {
                            id: this.examParams.id,
                            refId: this.examParams.refId,
                            isValid: this.examParams.isValid,
                            refType: this.examParams.refType,
                            backType: this.$route.query.backType || '',
                            goodsId: this.$route.query.goodsId || '',
                        }
                    })
                }
            });
        },
        findSomeOne() {
            this.chooseNum = null;
            this.allAnswer.forEach(val => {
                if(val.questionId === this.currentQuestion.optionList[0].questionId) {
                    this.chooseNum = val.userAnswer
                }
            })
            console.log('findSomeOne',this.allAnswer);
        },
        // 去重
        repetAnswer(params) {
            if (!params) return false;
            if (this.allAnswer.length > 0) {
                this.allAnswer.forEach((item) => {
                    if (params.questionId === item.questionId) {
                        this.allAnswer.splice(this.allAnswer.indexOf(item), 1);
                    }
                });
            }
            
            this.allAnswer.push(params);
            console.log('去重了',this.allAnswer);
        },
        // 切换题目
        async changeTopic(type) {
            let num = this.questionsList.indexOf(this.currentQuestion);
            num = num !== 0 && type === "prev" ? num - 1 : num + 1;
            let examLength=this.questionsList.length-1
            if(num>examLength ||num<0){
                return
            }
            this.currentQuestion = this.questionsList[num];
            this.currentRanking = num + 1;
            this.findSomeOne();
            this.pushState();
        },
        // 跳转到指定题目
        toThisOne(index) {
            this.currentRanking = index+1;
            this.isSheetShow = false;
            this.currentQuestion = this.questionsList[index];
            this.findSomeOne();
        },
        // 返回上题
        onTopic() {
            this.commitPaper();
        },
        pushState() {
            if (window.history && window.history.pushState) {
                // 往历史记录里面添加一条新的当前页面的url
                history.pushState(null, null, document.URL);
                // 给 popstate 绑定一个方法 监听页面刷新
                window.addEventListener('popstate', this.backChange, false);//false阻止默认事件
            }
        },
        commitPaper() {
            this.pushState();
            let noanswer = this.allAnswer.length < this.examTotal;
            console.log(this.allAnswer.length);
            console.log(this.examTotal);
            Dialog.confirm({
                className: 'respondDialog',
                message: noanswer ? "为保证测评准确性，请全部作答后提交" : "是否要进行交卷？",
                confirmButtonText:'提交',
                cancelButtonText:'继续答题',
                showConfirmButton: noanswer ? false : true,
            })
            .then(() => {
                this.allCommit()
            })
            .catch(() => {
                this.pushState();
            });
        },
        // 获取试题列表
        async findQuestForExam() {
            let data = {
                assessId: this.examParams.id,
                refId: this.examParams.refId,
                refType: this.examParams.refType,
            }
            this.$api.testreport.reportQuestionList({data}).then(res => {
                this.questionsList = res.data.examQuestionsList;
                this.examTotal = res.data.questionNum;
                this.currentQuestion = this.questionsList[0];
                this.showpage = res.data ? true : false;
                this.assessTime = res.data.assessTime * 60;
                if(sessionStorage.getItem('countDownTime') && this.assessTime>0){
                        const time1= sessionStorage.getItem('countDownTime');
                        const time2 = new Date().getTime();
                        const seconds = this.assessTime - (time2 -time1)/1000;
                        if(seconds>0){
                            this.countDown(seconds);
                        }else{
                            this.duration = '00:00:00'
                        }
                    }
            })
        },
        countDown(remainTime) {
            const that = this;
            this.timer = setInterval(()=>{
                if(remainTime>=0){
                    that.duration = that.timeFormat(remainTime);
                    remainTime -= 1;
                }else{
                    clearInterval(that.timer);
                }
            },1000)
        },
        timeFormat(time) {
            const hours = Math.floor(time / 60 / 60);
            const minutes = Math.floor((time / 60) % 60);
            const seconds = Math.floor(time % 60);
            const hours1 = hours < 10 ? `0${hours}` : hours;
            const minutes1 = minutes < 10 ? `0${minutes}` : minutes;
            const seconds1 = seconds < 10 ? `0${seconds}` : seconds;
            return `${hours1}:${minutes1}:${seconds1}`
        },
      findByIdAndRef() {
        //简介
        let data = {
          assessId: this.examParams.id,
          refId: this.examParams.refId,
          refType: this.examParams.refType,
        }
        this.$api.testreport.findByIdAndRef({data}).then(data => {
          this.leariningMsg = data.data;
        });
      }
    },
    mounted() {
        this.pushState();
        this.examParams = {...this.$route.query};
        this.findByIdAndRef();
        this.findQuestForExam();
        this.answerTime = formatTime(new Date());
        window.addEventListener("offline", ()=> {
            this.$toast({
                message:'网络异常',
                className:'respondPageToast'
            });
        }, false);
    },
    destroyed() {
        clearInterval(this.timer);
        sessionStorage.removeItem('countDownTime')
        sessionStorage.removeItem('assessTime')
    },
};
</script>
<style scoped lang="less">
@import "../asset/css/respondPage.less";
.intro-dialog{
    /deep/.van-dialog__content{
        width:100%;
        padding-left:15px;
        padding-right: 15px;
        box-sizing: border-box;
        max-height: 350PX;
        min-height: 200PX;
        font-size:14PX;
        line-height: 26PX;
        text-align: left;
        overflow: auto;
    }
}
</style>
<style lang="less">
.respondDialog{
    .van-dialog__content--isolated{
        min-height: 0px;
    }
    .van-dialog__footer{
        display: flex;
        padding: 0px 24px 24px;
        justify-content: center;
        &::after{
            border: none;
        }
        .van-button--default{
            border: 0px;
        }
        .van-button::before{
            background-color: transparent !important;
        }
        button{
            width: 128px !important;
            margin: 0px 10px;
        }
        .van-dialog__cancel{
            flex: none;
            .van-button__content{
                width: 128px;
                height: 40px;
                border-radius: 22px;
                border: 1px solid #415FF6;
                color: #415FF6;
            }
        }
        .van-dialog__confirm{
            flex: none;
            .van-button__content{
                // width: 128px;
                height: 40px;
                background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
                border-radius: 22px;
                color: #fff;
            }
        }
    }
}
@import '../asset/css/respondPage1.less';
</style>
